export default function extractPathname(url?: string): string {
  if (!url) {
    return '';
  }

  const parsedUrl = new URL(url, 'https://sidelineswap.com');
  return parsedUrl.pathname + (parsedUrl.search || '');
}
